<div class="side-content">
  @defer (when !$isLoading() && $tasks()) {
    @if ($filtered()) {
      <div class="flex justify-between items-center border-b-2">
        <ui-goback-to-list (goBackToList)="goBackToAllTaskList()" />

        @let taskCount = $tasks()?.length || 0;
        @let taskLabel = taskCount === 1 ? "Task" : "Tasks";
        @let taskCountDisplay = taskCount + " " + taskLabel;
        <p class="flex">
          Showing:
          <wcg-chip
            data-testid="task-list__filtered-info"
            [type]="filteredChipType"
            [label]="taskCountDisplay"
            [size]="filteredChipSize"
          />
        </p>
      </div>
    }
    @for (task of $tasks(); track task.id) {
      <ui-task-item
        [task]="task"
        [uploadButtonTemplate]="uploadButtonTemplate"
        [asigneeInfoTemplate]="asigneeInfoTemplate"
        [messageTemplate]="messageTemplate"
        (selectedTask)="viewTaskDetail($event)"
        class="border"
      />
    }
  }
</div>
<ng-template #uploadButtonTemplate let-task>
  <wcg-button
    data-testid="task-item__upload-documents"
    color="tertiary"
    size="slim"
    (click)="uploadTaskDocument(task)"
  >
    <mat-icon fontSet="material-symbols-outlined">upload</mat-icon>
    Upload Document
  </wcg-button>
</ng-template>

<ng-template #asigneeInfoTemplate let-task="task">
  <div class="flex justify-between text-gray-500 mb-1">
    <div class="flex items-center gap-1">
      @if (task.active_assignee) {
        <ui-assignee [assignee]="task.active_assignee" />
      }
    </div>
  </div>
</ng-template>
<ng-template #messageTemplate let-task="task">
  @if ($currentStage() !== "draft" && !noMessagesTasks.has(task.task_type)) {
    <div class="cursor-pointer flex gap-2">
      <mat-icon
        fontSet="material-icons-outlined"
        (click)="viewTaskDetail(task!)"
        >chat</mat-icon
      >
      <span>{{ task?.message_count }}</span>
    </div>
  }
</ng-template>
